export let contentData = {};
export let default_langauge = "";
export let experience_locale = {};
export let tracking_type = "";
export let post_completion_mode = "";
export let resources = [];
export let bites = [];
export let assets = [];
export let default_progress_label = "Continue";
export let strings = {};
export let user_role = "";
export let user_name = "";
export let localeOptions = {};
export let languages = [];

//export let toolbox_locale = {};
//export let menu = {};
//export let achievements = [];
//
export function setObject(string, value){
    return this[string] = Object.assign({},value);
}

export function setArray(string, value) {
    this[string] = Object.assign([], value);
}

export function set(string, value){
    this[string] =  value;
}






/** WEBPACK FOOTER **
 ** ./src/localStorage/localStorage.js
 **/